const MessageType = {
  text: "0",
  image: "1",
  file: "2",
  voice : '3',
  video : '4',
  lpVideo : '6',
};
export default MessageType;
